/* Tailor Hats redesign — small behaviors. No dependencies. */
(function () {
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function init(root) {
    root = root || document;

    qsa('[data-th-burger]', root).forEach(function (btn) {
      if (btn._th) return; btn._th = 1;
      var drawer = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open);
        drawer.classList.toggle('is-open', open);
        btn.textContent = open ? '✕' : '☰';
      });
    });

    qsa('[data-th-acc-single]', root).forEach(function (acc) {
      if (acc._th) return; acc._th = 1;
      qsa('details', acc).forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          qsa('details', acc).forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });

    qsa('[data-th-faq]', root).forEach(function (faq) {
      if (faq._th) return; faq._th = 1;
      var btns = qsa('[data-th-cat]', faq), groups = qsa('[data-th-group]', faq);
      function show(cat) {
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.thCat === cat); });
        groups.forEach(function (g) { g.hidden = g.dataset.thGroup !== cat; });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.dataset.thCat); }); });
      var hash = (location.hash || '').replace('#', '');
      var start = btns.filter(function (b) { return b.dataset.thCat === hash; })[0] || btns[0];
      if (start) show(start.dataset.thCat);
    });

    qsa('[data-th-filters]', root).forEach(function (wrap) {
      if (wrap._th) return; wrap._th = 1;
      var scope = wrap.closest('section') || document;
      var chips = qsa('[data-th-filter]', wrap);
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var f = c.dataset.thFilter;
          chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c); });
          qsa('[data-th-tags]', scope).forEach(function (it) {
            it.hidden = !(f === 'all' || (' ' + it.dataset.thTags + ' ').indexOf(' ' + f + ' ') > -1);
          });
        });
      });
    });

    qsa('[data-th-finder]', root).forEach(function (box) {
      if (box._th) return; box._th = 1;
      var input = box.querySelector('input'), out = box.querySelector('[data-th-result]');
      var units = qsa('[data-th-unit]', box), unit = 'in';
      var table = document.querySelector('[data-th-chart]');
      function calc() {
        var v = parseFloat(input.value);
        qsa('tr[data-in]', table || box).forEach(function (r) { r.classList.remove('is-match'); });
        if (!v) { out.textContent = '—'; return; }
        var inches = unit === 'cm' ? v / 2.54 : v;
        if (inches < 20.5 || inches > 24.6) { out.textContent = 'Outside our standard range. Get fitted in person.'; return; }
        var rows = qsa('tr[data-in]', table || box), best = null, diff = 99;
        rows.forEach(function (r) { var d = Math.abs(parseFloat(r.dataset.in) - inches); if (d < diff) { diff = d; best = r; } });
        if (best) { best.classList.add('is-match'); out.textContent = best.dataset.size; }
      }
      units.forEach(function (b) {
        b.addEventListener('click', function () {
          var next = b.dataset.thUnit; if (next === unit) return;
          var v = parseFloat(input.value);
          if (v) input.value = next === 'cm' ? (v * 2.54).toFixed(1) : (v / 2.54).toFixed(2);
          unit = next;
          units.forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
          calc();
        });
      });
      input.addEventListener('input', calc);
    });

    qsa('[data-th-builder]', root).forEach(function (b) {
      if (b._th) return; b._th = 1;
      var line = b.querySelector('[data-th-line]'), color = b.dataset.color || '';
      function update() {
        var parts = [color];
        qsa('[data-th-group]', b).forEach(function (g) {
          var sel = g.querySelector('[aria-pressed="true"]');
          var val = sel ? sel.dataset.value : '';
          var label = g.querySelector('.th-label');
          var sec = b.closest('section') || document;
          var prop = label && sec.querySelector('[data-th-prop="' + label.textContent.trim() + '"]');
          if (prop) prop.value = val;
          if (val) parts.push(g.dataset.thPrefix ? g.dataset.thPrefix + ' ' + val : val);
        });
        if (line) line.textContent = 'Your hat: ' + parts.filter(Boolean).join(' · ');
      }
      qsa('[data-th-group]', b).forEach(function (g) {
        qsa('.th-chip', g).forEach(function (c) {
          c.addEventListener('click', function () {
            qsa('.th-chip', g).forEach(function (o) { o.setAttribute('aria-pressed', o === c); });
            update();
          });
        });
      });
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
